module.exports = __webpack_public_path__ + "static/media/chat02.ed30739f.png";